import { render, staticRenderFns } from "./PrinterProfile.vue?vue&type=template&id=c528ef90"
import script from "./PrinterProfile.vue?vue&type=script&lang=js"
export * from "./PrinterProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports